<template>
  <div class="box-detail">
    <div class="box-left">
      <!-- <div class="box-left-header">
        <div @click="$router.push({ path: '/materials' })" class="goBack c-position-static c-m-0">
          <i class="el-icon-arrow-left"></i>
          <span>材料列表</span>
          <i class="el-icon-box"></i>
        </div>
      </div> -->
      <div class="box-left-content">
        <c-form
          :formData="formData"
          :fields="extFields"
          :options="options"
          ref="form"
          :upload="upload"
          @changeForm="osg.changeForm"
        ></c-form>
      </div>
      <div class="box-left-footer">
        <el-button type="primary" @click="doSave()">提交</el-button>
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <div class="box-center">
      <el-tabs v-model="activeTab" @tab-click="tabClick">
        <el-tab-pane label="销售属性和价格" name="attribute">
          <div class="box-center-content c-p-0 c-flex c-flex-col">
            <div style="padding:10px;background:#fff;border-radius: 5px;">
              <h4 class="c-m-b-10">销售属性</h4>
              <template v-for="(f, i) in extFields">
                <div
                  v-if="f.frontEndConfig.salesAttribute"
                  :key="i"
                  class="c-flex"
                  style="margin: 5px 0;padding-bottom: 5px;"
                >
                  <span style="min-width:50px;font-size:14px;height:32px;line-height:32px;">
                    {{ f.nameDisp }}
                  </span>
                  <div v-if="formData.exts[f.name]">
                    <el-select
                      v-for="(value, i) in formData.exts[f.name]"
                      :key="i"
                      v-model="formData.exts[f.name][i]"
                      clearable
                      @clear="
                        () => {
                          formData.exts[f.name].splice(i, 1);
                        }
                      "
                      style="margin:0 5px 5px 0;"
                    >
                      <el-option
                        v-for="item in options[f.valueOption]"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="formData.exts[f.name].indexOf(item.value) != -1"
                      ></el-option>
                    </el-select>
                  </div>
                  <div>
                    <el-button
                      v-if="
                        !formData.exts[f.name] ||
                          formData.exts[f.name].length < options[f.valueOption].length
                      "
                      @click="
                        () => {
                          if (!formData.exts[f.name]) {
                            $set(formData.exts, f.name, []);
                          }
                          formData.exts[f.name].push('');
                        }
                      "
                      type="primary"
                      icon="el-icon-circle-plus-outline"
                    >
                      添加属性值
                    </el-button>
                  </div>
                </div>
              </template>
            </div>
            <div style="flex:1;margin-top:15px;padding:10px;background:#fff;border-radius: 5px;">
              <div class="c-flex c-flex-between c-flex-item c-m-b-10">
                <h4>SKU组合列表</h4>
                <div>
                  <el-button @click="createSKU" type="primary">生成SKU组合列表</el-button>
                  <el-button @click="submitSKU" type="success">提交SKU商品</el-button>
                </div>
              </div>
              <el-form style="height:calc(100% - 45px)" :model="sku" ref="skuRuleForm">
                <el-table
                  :data="sku.newData"
                  border
                  class="c-table-border"
                  :span-method="mergeCells"
                  height="100%"
                >
                  <el-table-column
                    v-for="(f, i) in sku.attributeFields"
                    :key="i"
                    :prop="'exts.' + f.name"
                    :label="f.nameDisp"
                    :formatter="
                      (row, column, cellValue) => {
                        return osg.codelabel(f.valueOption, cellValue);
                      }
                    "
                  ></el-table-column>
                  <el-table-column label="价格">
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="'newData.' + scope.$index + '.price'"
                        :rules="{
                          required: scope.row.state == 1 || scope.row.code ? true : false,
                          message: '请填写',
                          trigger: 'change'
                        }"
                        style="margin-bottom:0"
                      >
                        <el-input-number
                          style="width:100%"
                          v-model="scope.row.price"
                          :precision="2"
                          :controls="false"
                          :min="0"
                        ></el-input-number>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="编号">
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="'newData.' + scope.$index + '.code'"
                        :rules="{
                          required:
                            scope.row.state == 1 || scope.row.price || scope.row.price === 0
                              ? true
                              : false,
                          message: '请填写',
                          trigger: 'change'
                        }"
                        style="margin-bottom:0"
                      >
                        <el-input v-model="scope.row.code"></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="上架/下架">
                    <template slot-scope="scope">
                      <el-switch
                        v-model="scope.row.state"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        :active-value="1"
                        :inactive-value="0"
                      ></el-switch>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="非适用范围" name="scope">
          <div class="box-center-tool">
            <div></div>
            <div>
              <el-button type="primary" size="mini" @click="scopeSave">
                保存非适用范围
              </el-button>
            </div>
          </div>
          <div class="box-center-content">
            <el-tree
              :data="scope.orgs"
              ref="scope"
              node-key="_id"
              :props="{ label: 'orgName', children: 'orgList' }"
              :expand-on-click-node="false"
              check-on-click-node
              show-checkbox
              default-expand-all
              :indent="50"
            ></el-tree>
          </div>
        </el-tab-pane>
        <el-tab-pane label="价格表" name="price" v-if="false">
          <div class="box-center-tool">
            <div></div>
            <div>
              <el-button type="primary" size="mini" @click="openPrice">
                添加价格
              </el-button>
              <el-dropdown
                class="c-m-l-10"
                @command="priceaudit"
                v-if="osg.has('Materials,priceAudit')"
              >
                <el-button type="primary" size="mini">
                  审核
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="1">审核通过</el-dropdown-item>
                  <el-dropdown-item command="2">审核不通过</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="box-center-content settleTable">
            <el-table
              @selection-change="selectRows"
              ref="price"
              :data="price.fpi.data"
              border
              class="c-m-t-10"
            >
              <el-table-column
                v-if="osg.has('Materials,priceAudit')"
                type="selection"
                width="55"
              ></el-table-column>
              <el-table-column label="组织" fixed width="250px">
                <template slot-scope="current">
                  <el-cascader
                    v-model="current.row.orgId"
                    :show-all-levels="false"
                    disabled
                    :options="scope.orgs"
                    :props="{
                      checkStrictly: true,
                      emitPath: false,
                      label: 'orgName',
                      value: '_id',
                      children: 'orgList'
                    }"
                    clearable
                  ></el-cascader>
                </template>
              </el-table-column>
              <el-table-column prop="guideUnitPrice" label="单价" width="150"></el-table-column>
              <el-table-column
                prop="minimumGuideTotalPrice"
                label="最低指导价"
                width="150"
              ></el-table-column>
              <el-table-column
                prop="approveState"
                label="审核状态"
                :formatter="formatApproveState"
                width="150"
              ></el-table-column>

              <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                  <el-button @click="priceEdit(scope.row)" size="mini">
                    编辑
                  </el-button>
                  <el-button
                    @click="priceDelete(scope.row._id)"
                    size="mini"
                    style="margin-left:10px"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <el-dialog title="新增价格" :visible.sync="price.open">
            <el-form
              :model="price.formData"
              :rules="rules"
              ref="priceFormData"
              label-width="110px"
              label-position="left"
            >
              <el-form-item
                label="组织"
                prop="orgId"
                :rules="{
                  required: true,
                  trigger: ['change'],
                  message: '请选择组织'
                }"
              >
                <el-cascader
                  v-model="price.formData.orgId"
                  :options="scope.orgs"
                  :props="{
                    checkStrictly: true,
                    emitPath: false,
                    label: 'orgName',
                    value: '_id',
                    children: 'orgList'
                  }"
                  clearable
                ></el-cascader>
              </el-form-item>

              <el-form-item
                label="单价"
                prop="guideUnitPrice"
                :rules="{
                  required: true,
                  trigger: ['input'],
                  message: '请输入单价'
                }"
              >
                <el-input v-model="price.formData.guideUnitPrice" type="number"></el-input>
              </el-form-item>

              <el-form-item
                label="最低指导价"
                prop="minimumGuideTotalPrice"
                :rules="{
                  required: true,
                  trigger: ['input'],
                  message: '请输入最低指导价'
                }"
              >
                <el-input v-model="price.formData.minimumGuideTotalPrice" type="number"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer">
              <el-button type="primary" @click="priceSave()">提 交</el-button>
              <el-button @click="doInit">取 消</el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="动态" name="log">
          <div class="box-center-tool">
            <div>
              <el-date-picker
                v-model="log.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="getLog"
                class="search-date"
              ></el-date-picker>
            </div>
            <div>
              <el-input
                placeholder="请输入标题/内容"
                v-model="log.searchValue"
                class="search-input"
                clearable
                @clear="getLog"
                @keyup.enter.native="getLog"
              >
                <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
              </el-input>
            </div>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
              <div class="activity-card-header">
                <span class="c-font-500">
                  <i class="el-icon-monitor c-w-30"></i>
                  {{ log.title }}
                </span>
                <span>{{ log.createTime }}</span>
              </div>
              <div class="activity-card-content">
                {{ log.content }}
              </div>
              <div class="activity-card-footer">
                <span>操作人：{{ log.updateUserName }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="笔记" name="notes">
          <div class="box-center-tool">
            <div></div>
            <el-button
              type="primary"
              size="mini"
              @click="
                vqeditor.content = ``;
                openNote = true;
              "
            >
              创建笔记
            </el-button>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(note, i) in noteData" :key="i">
              <div class="activity-card-header">
                <span>
                  <i class="el-icon-edit-outline c-w-30"></i>
                  笔记
                </span>
                <span>{{ note.createTime }}</span>
              </div>
              <div
                class="activity-card-content-node"
                v-html="note.content"
                @click="noteMdShow(note)"
                v-if="!note.openNote"
              ></div>
              <c-editor
                v-else
                class="c-m-15"
                :formData="note"
                :value="'content'"
                ref="editor"
              ></c-editor>
              <div class="activity-card-footer">
                <span>操作人：{{ note.createUserName }}</span>
              </div>
            </div>
          </div>
          <!-- markdown编辑器 -->
          <el-dialog title="笔记" :visible.sync="openNote">
            <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
            <div slot="footer">
              <el-button type="primary" @click="saveNote">确 认</el-button>
              <el-button
                @click="
                  openNote = false;
                  vqeditor.content = '';
                "
              >
                取 消
              </el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="属性变更记录" name="history">
          <div
            class="box-center-content"
            v-infinite-scroll="getHistory"
            :infinite-scroll-immediate="true"
          >
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- <div class="box-right" :class="collapse ? 'box-collapse' : ''">
      <div class="box-right-header">
        <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
        <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
      </div>
      <div class="box-right-content" v-show="!collapse">
        <el-collapse v-model="activeCollapse"></el-collapse>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'material',
  data() {
    window.$this = this;
    return {
      id: null,
      collapse: true,
      activeCollapse: '1',
      tenantId: '',
      loginOrgId: '',
      formData: {
        exts: {}
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      fieldsObj: {},
      options: {
        codecfg_auditStatus: { codeId: 'auditStatus' },
        codecfg_unit: { codeId: 'UNIT' },
        codecfg_type1: { codeId: 'type1' }
      },
      rules: this.$util.rules,
      // 异处
      activeTab: 'attribute',
      scope: {
        open: false,
        orgs: []
      },
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      noteData: [],
      openNote: false,
      vqeditor: this.$util.vqeditor,
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: window.$this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      sku: {
        // 查询到的关联的sku产品
        oldData: [],
        // sku组合列表
        newData: [],
        // 有值的属性字段
        attributeFields: [],
        // 各属性的属性值个数
        attributeNumbers: []
      },
      price: {
        fpi: { pages: 1, rows: 10, data: [] },
        formData: {},
        open: false,
        searchValue: '',
        selectedRows: []
      }
    };
  },
  mounted() {
    this.id = this.osg.param('id');
    // 获取当前租户id和登录人组织id
    let account = JSON.parse(sessionStorage['loginAccount']);
    this.tenantId = account.tenantId;
    this.loginOrgId = account.orgId;
    this.doInit();

    this.osg.getFields('material', () => {
      this.getData(() => {
        // 查询sku
        this.getSKU();
        this.getOrgs(() => {
          // 自动勾选已选中的组织
          this.$refs.scope.setCheckedKeys(this.formData.scopeJson || []);
        });
      });
    });
  },
  methods: {
    formatApproveState(row, column, cellValue) {
      return this.osg.codelabel('auditStatus', cellValue);
    },
    getData(callback) {
      this.osg.ajax(
        `basic/material/findById/${this.id}.do`,
        {},
        res => {
          res.entity.exts = res.entity.exts || {};
          let row = res.entity;
          this.$util.renderExtField(this.extFields, row);
          // 解析图片
          if (row.images) {
            if (this.$util.isJson(row.images)) {
              row.images = JSON.parse(row.images);
            }
          } else {
            row.images = [];
          }
          this.formData = row;

          if (callback) callback(res);
          //获取属性修改记录
          this.getHistory();
        },
        {
          noload: true
        }
      );
    },
    doSave() {
      if (this.osg.validate()) {
        let row = this.$util.deepCopy(this.formData);
        row.approveState = 0;
        // 超级管理员、平台管理员、当前组织都可以看到此条数据
        row.scopeIds = row.scopeIds || [];
        // if (row.scopeIds.indexOf('0') == -1) row.scopeIds.push('0');
        // if (row.scopeIds.indexOf(this.tenantId) == -1) row.scopeIds.push(this.tenantId);
        // if (row.scopeIds.indexOf(this.loginOrgId) == -1) row.scopeIds.push(this.loginOrgId);

        this.$util.saveExtField(this.extFields, row);
        row.images.map(item => {
          if (item.url.indexOf('blob:') != -1) {
            item.url = this.upload.downloadUrl + item.response.key;
          }
        });
        row.images = JSON.stringify(row.images);
        this.osg.ajax(
          'basic/material/jsonUpsert.do',
          { data: JSON.stringify(row) },
          () => {
            this.osg.toast('保存成功！');
            this.getData();
          },
          {
            noload: true
          }
        );
      }
    },
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: 'material',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res.data.length > 0) {
            // 不需要展示变更的字段名
            res.data = res.data.filter(item => {
              item.modifyList = item.modifyList.filter(obj => {
                return (
                  this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
                );
              });
              return item.modifyList.length > 0;
            });
            this.historyFpi = res;
          }
        },
        { noload: true }
      );
    },
    formatField(row, column, cellValue) {
      return this.osg.codelabel('fields', cellValue);
    },
    formatFieldValue(row, column, cellValue) {
      if (this.options[row.field]) {
        return this.osg.codelabel(row.field, cellValue);
      } else {
        return cellValue;
      }
    },
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: 'material'
        },
        res => {
          this.noteData = res || [];
        },
        { noload: true }
      );
    },
    saveNote() {
      var params = {
        sid: this.id,
        smodule: 'material',
        content: this.vqeditor.content
      };
      this.osg.ajax('note/upsert.do', params, () => {
        this.openNote = false;
        this.getNote();
      });
    },
    noteMdShow(note) {
      note.openNote = true;
    },
    // 点击标签栏
    tabClick(tab) {
      switch (tab.name) {
        case 'attribute':
          this.getSKU();
          break;
        case 'scope':
          // 自动勾选已选中的组织
          this.$refs.scope.setCheckedKeys(this.formData.scopeJson || []);
          break;
        case 'price':
          this.getPrice();
          break;
        case 'log':
          this.getLog();
          break;
        case 'notes':
          this.getNote();
          break;
        case 'history':
          this.getHistory();
          break;
        default:
      }
    },
    /**
     * 适用范围
     */
    getOrgs(callback) {
      this.osg.ajax(
        'org/query.do',
        {
          notFilterOrgId: '1',
          sortField: 'order'
        },
        res => {
          res.data.orgName = res.data.orgName || '全部组织';
          this.scope.orgs = [res.data];
          if (callback) callback();
        }
      );
    },
    scopeSave() {
      this.formData.scopeJson = this.$refs.scope.getCheckedKeys(true); // true:仅返回全选中的叶子节点的keys false:返回所有全选中的节点
      let scopeIds = this.$refs.scope.getCheckedKeys();
      this.formData.scopeIds = scopeIds;
      // if (!scopeIds.length == 0) {
      //   // .concat(this.$refs.scope.getHalfCheckedKeys());
      //   // if(scopeIds.indexOf('0') == -1)scopeIds.push('0');    1340835581184723420
      //   c
      // } else {
      //   this.formData.scopeIds = [this.tenantId];
      // }
      this.doSave();
    },
    getSKU() {
      if (!this.formData._id) return;
      this.osg.ajax(
        'basic/material/query.do',
        {
          _all: '1',
          'in:state|array-integer#and': '0,1',
          spuid: this.formData._id
        },
        res => {
          this.sku.oldData = res.data;
          if (res.data.length > 0) {
            this.createSKU();
          }
        }
      );
    },
    // 生成SKU组合列表
    createSKU() {
      let attributeFields = [];
      let attributeNumbers = [];
      this.$refs.skuRuleForm.clearValidate();
      this.extFields.map(item => {
        if (
          item.frontEndConfig.salesAttribute &&
          this.formData.exts[item.name] &&
          this.formData.exts[item.name].length > 0
        ) {
          attributeFields.push(item);
          attributeNumbers.push(this.formData.exts[item.name].length);
        }
      });
      // 有值的属性字段
      this.sku.attributeFields = attributeFields;
      // 各属性的属性值个数
      this.sku.attributeNumbers = attributeNumbers;
      if (this.sku.attributeFields.length == 0) {
        this.osg.toast('请至少添加1个属性值！', 'warning');
        this.sku.newData = [];
        return;
      }

      // 递归生成全部组合数据
      let newData = [];
      let that = this;
      function getAllCombinations(index, parentData) {
        let fieldName = attributeFields[index].name;
        let fieldValues = that.formData.exts[fieldName];

        for (let value of fieldValues) {
          if (!value) {
            that.osg.toast('属性值不能为空！', 'warning');
            return;
          }
          if (index == attributeFields.length - 1) {
            // 最后一个属性
            let row = { price: that.formData.price, exts: {} };
            parentData.map(item => {
              row.exts[item.fieldName] = item.value;
            });
            row.exts[fieldName] = value;
            newData.push(row);
          } else {
            // 非最后一个属性,继续递归循环
            parentData.push({ fieldName, value });
            getAllCombinations(index + 1, parentData);
          }
        }
      }
      getAllCombinations(0, []);

      // 将已有sku数据覆盖到新组成的sku数据中
      newData.map(row => {
        for (let i = 0; i < this.sku.oldData.length; i++) {
          let obj = this.sku.oldData[i];
          let matching = true;
          for (let j = 0; j < attributeFields.length; j++) {
            let fieldName = attributeFields[j].name;
            if (row.exts[fieldName] != obj.exts[fieldName]) {
              matching = false;
              break;
            }
          }
          // 完全匹配将覆盖当前行数据
          if (matching) {
            row = Object.assign(row, obj);
          }
        }
      });
      this.sku.newData = newData;
    },
    // 合并相同属性的单元格
    mergeCells({ rowIndex, columnIndex }) {
      for (let i = 0; i < this.sku.attributeNumbers.length - 1; i++) {
        if (columnIndex === i) {
          let number = 1;
          for (let j = i + 1; j < this.sku.attributeNumbers.length; j++) {
            number = number * this.sku.attributeNumbers[j];
          }

          if (rowIndex % number === 0) {
            return {
              rowspan: number,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      }
    },
    submitSKU() {
      if (this.sku.newData.length == 0) {
        this.osg.toast('请先生成SKU组合列表！', 'warning');
        return;
      }
      this.$refs['skuRuleForm'].validate(valid => {
        if (!valid) return;
        let newData = this.$util.deepCopy(this.sku.newData);
        for (let i = 0; i < newData.length; i++) {
          let row = newData[i];
          if (row.state == 1 && row.price == 0) {
            this.osg.toast('SKU单价不能为0！');
            return;
          }
          // 按照属性组合商品标题
          let attributeTitle = '';
          this.sku.attributeFields.map(item => {
            attributeTitle += ' ' + this.osg.codelabel(item.valueOption, row.exts[item.name]);
          });
          row.name = row.name || this.formData.name + attributeTitle;
          row.spec = row.spec || this.formData.spec;
          row.spec = row.specUnit || this.formData.specUnit;
          row.type = row.type || this.formData.type;
          row.materialUnit = row.materialUnit || this.formData.materialUnit;

          if (row.state == 1) {
            // 1.上架的
            row.spuid = this.formData._id;
          } else {
            // 2.下架的
            if (!row.price && row.price !== 0 && !row.code) {
              // 2.1价格和编号都没值
              if (row._id) {
                // 3.1 之前已生成产品的sku 状态改为-1
                row.state = -1;
                row.spuid = this.formData._id;
              } else {
                // 3.2 刚生成的sku 不添加spuid 不保存数据
              }
            } else {
              // 2.2价格和编号都有值 状态改为0禁用
              row.state = 0;
              row.spuid = this.formData._id;
            }
          }
        }

        // 将取消的sku，状态改为-1
        let removeOldData = [];
        this.sku.oldData.map(item => {
          if (newData.find(obj => item._id == obj._id) == undefined) {
            item.state = -1;
            removeOldData.push(item);
          }
        });

        // 保存spu属性
        if (this.osg.validate()) {
          this.doSave();
        } else {
          this.osg.toast('请检查左侧表单字段是否完整！', 'warning');
          return;
        }

        // 只保存有spuid的sku数据，和被删除的sku
        this.osg.ajax(
          'basic/material/batchUpsert.do',
          {
            data: JSON.stringify(newData.filter(item => item.spuid).concat(removeOldData))
          },
          () => {
            // 更新页面数据
            this.getSKU();
          }
        );
      });
    },
    getPrice() {
      let params = {
        page: this.price.fpi.page,
        rows: this.price.fpi.rows,
        'is:measureId|string#and': this.formData._id,
        'regex:name|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      this.osg.ajax('biz/material/body/query.do', params, res => {
        // 解析json字符串的字段
        this.$util.renderExtFields(this.extFields, res.data);
        this.price.fpi = res;
        this.$nextTick(() => {
          this.$refs.price.doLayout();
          this.$forceUpdate();
        });
      });
    },
    priceSave() {
      if (this.osg.validate('priceFormData')) {
        let params = this.price.formData;
        params.measureId = this.formData._id;
        params.approveState = 0; //修改数据时审核状态改为0
        this.osg.ajax(
          'biz/material/body/upsert.do',
          params,
          () => {
            this.osg.toast('保存成功！');
            this.price.open = false;
            this.price.formData = {};
            this.doInit();
            this.getPrice();
          },
          {
            noload: true
          }
        );
      }
    },
    doInit() {
      // this.formData = {scopeIds:[], exts: {} };
      this.price.open = false;
      //  this.price.open = true;
      // this.$util.renderExtField(this.extFields, this.formData);
    },
    openPrice() {
      this.price.formData = this.$util.deepCopy();
      this.price.open = true;
    },
    priceEdit(row) {
      this.price.formData = this.$util.deepCopy(row);
      this.price.open = true;
    },
    priceDelete(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(`biz/material/remove/body/${id}.do`, null, () => {
          this.osg.toast('删除成功');
          this.getPrice();
        });
      });
    },
    // 列表多选
    selectRows(rows) {
      this.price.selectedRows = rows;
    },
    //审核
    priceaudit(approveState) {
      /**
       * auditStatus
       * 0:待审核（新建后是自由态-->审核状态设为0:待审核）
       * 1:审核通过（平台点审核通过-->审核状态改为1:审核通过）
       * 2:审核不通过（平台点审核通过-->审核状态改为2:审核不通过）
       */
      // 至少选择一个产品
      if (this.price.selectedRows.length == 0) {
        this.osg.toast('请至少勾选一条待审核的数据', 'warning');
        return;
      }
      // 判断选择的产品状态是否符合审核条件
      let msg = '';
      let confirmMsg = '';
      switch (approveState) {
        case '1':
          for (let row of this.price.selectedRows) {
            if (row.approveState != '0') {
              this.osg.alert(`您选择的“${row.name}”，不是“待审核”状态！`);
              return;
            }
          }
          confirmMsg = '审核通过';
          msg = '审核通过，处理完成。';
          break;
        case '2':
          for (let row of this.price.selectedRows) {
            if (row.approveState != '0') {
              this.osg.alert(`您选择的“${row.name}”，不是“待审核”状态！`);
              return;
            }
          }
          confirmMsg = '审核不通过';
          msg = '审核不通过，处理完成。';
          break;
        default:
      }
      this.osg.confirm(`是否确认“${confirmMsg}”？`, () => {
        this.auditConfirm(approveState, msg);
      });
    },
    auditConfirm(approveState, msg) {
      let ids = [];
      this.price.selectedRows.map(item => {
        ids.push(item._id);
      }),
        this.osg.ajax(
          'biz/material/approve/body.do',
          {
            ids: ids.join(),
            approveState: approveState
            // data: JSON.stringify({
            //   datas: this.price.selectedRows,
            //   newAuditStatus: approveState,
            //   // remark: this.auditObj.remark || null
            // })
          },
          () => {
            this.osg.toast(msg);
            // this.auditObj.remark = '';
            // this.auditObj.show = false;
            this.getPrice();
          }
        );
    }
  }
};
</script>
